/* eslint-disable @typescript-eslint/naming-convention */
import {Organization} from 'api/types/organisationTypes';
import {OrganizationDTO} from 'api/typesDTO/organisationDTO';

/**
 * Converts client-side `Organisation` to server-side `OrganisationDTO`
 * @param organisation `Organisation` to convert to `OrganisationDTO`
 */
export function convertOrganizationToOrganizationDTO(
  organisation: Organization
): OrganizationDTO {
  const {id, name, maxContentCreators, maxLearners} = organisation;

  return {
    id,
    name,
    max_students: maxLearners,
    max_teachers: maxContentCreators,
  };
}

/**
 * Converts server-side `OrganisationDTO` to client-side `Organisation`
 * @param organisationDTO `OrganisationDTO` to covnert to `Organisation`
 */
export function convertOrganizationDTOToOrganization(
  organisationDTO: OrganizationDTO
): Organization {
  const {
    id,
    name,
    max_students: maxLearners,
    max_teachers: maxContentCreators,
    current_managers: currentManagers,
    current_content_creators: currentContentCreators,
    current_learners: currentLearners,
  } = organisationDTO;

  return {
    id,
    name,
    maxLearners,
    maxContentCreators,
    currentManagers,
    currentContentCreators,
    currentLearners,
  };
}
